import PopupManager from "../../Common/Popups/PopupManager";
import { setDatabaseNeedsUpdating } from "../../Data/DataStores/DataSource";
import { setOption, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Bootstrapper } from "../Bootstrapper";

export class VersionBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        setOption("__shopfront_version", __VERSION__.commit);
        subscribeToOption("__shopfront_version", (
            _,
            newValue
        ) => {
            if(newValue !== __VERSION__.commit) {
                console.log("Showing version outdated toast");
                setDatabaseNeedsUpdating();
                const id = "shopfront-version-outdated";

                PopupManager.create({
                    id,
                    message: (
                        <a
                            href="#"
                            onClick={(e: React.MouseEvent): void => {
                                e.preventDefault();
                                window.location.reload();
                            }}
                        >
                            A new version of Shopfront is now available, please click here when you can
                            to refresh the page. Some parts of the POS system may not work properly until
                            this is done on any page with this message.
                        </a>
                    ),
                    icon   : "exclamation",
                    classes: [ "popup-warning" ],
                    timeout: 0,
                });
            }
        });
    }
}
